;(function () {

"use strict";

var FileUploadView = Backbone.View.extend({
  val: function () {
    if (this.$el[0].files[0]) {
      this.filename = this.$el[0].files[0].name;
    }

    return [this.$el[0].files[0]];
  }
});

module.exports = FileUploadView;

}());